import { Stack, useColorModeValue } from "@chakra-ui/react";

import MobileNavItem from "./MobileNavItem";
import NavItem from "./NavItem";

function MobileNav(props: { items: NavItem[] }) {
  return (
    <Stack
      background={useColorModeValue("white", "gray.800")}
      display={{ md: "none" }}
      p={4}
    >
      {props.items.map((navItem) => (
        <MobileNavItem key={navItem.label} {...navItem} />
      ))}
    </Stack>
  );
}

export default MobileNav;
